<template>
  <div :class="eqDivClass">
    <cargo-ag-grid
      v-if="job.lob === 'SI'"
      config-module="130003"
      :grid-options="gridOptions"
      :column-defs="finalColumnDefs"
      :row-data="finalRowData"
      :auto-fit-content="false"
      style="width:100%;height:200px;margin-bottom: 5px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <cargo-ag-grid
      v-else
      :grid-options="gridOptions"
      :column-defs="finalColumnDefs"
      :show-side-bar="false"
      :row-data="finalRowData"
      :auto-fit-content="false"
      style="width:100%;height:200px;margin-bottom: 5px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div style="width:100%">
      <div style="text-align: right;margin-bottom: 5px">
        <el-button v-show="isEdit&&((containerLoadType!=='BB' || isXy) ||hideSoc)" no="Add" type="primary" @click="add">{{ $t('SeaExport.Add') }}</el-button>&nbsp;
        <el-button v-show="(isEdit&&((containerLoadType!=='BB' || isXy) ||hideSoc)) || (isEdit && containerLoadType === 'BB' && rowData && (rowData.length > 1 || isXy))" no="Delete" type="danger" @click="remove">{{ $t('SeaExport.Delete') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { EQ_SIZES, EQ_SIZES_3 } from '@/class/cargo/model/parameters/EQSize'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import uidUtil from '@/utils/uidUtil'
import { sleep } from '@/utils/commonUtil'
import ContainerNoHelper from '../../../utils/containerNoHelper'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import StrUtils from '@/utils/StrUtils'
import lang from '@/lang'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'BookingSeaEqDataGrid',
  components: { },
  props: {
    job: { type: Object, required: true },
    value: { type: Array, default: () => [] },
    containerLoadType: { type: String, default: '' },
    isEdit: { type: Boolean, required: true },
    hideSoc: { type: Boolean, default: false },
    hideContainerNo: { type: Boolean, default: true },
    lob: { type: String, default: '' },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eqSizes: EQ_SIZES,
      eqTypes: [],
      defaultSeaEQ: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        rowHeight: 32,
        unSortIcon: true,
        onCellFocused: (event) => {
          this.onUpCellFocused(event)
        },
        onRowClicked: this.rowClicked,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedSeaEQ: null, // 当前选中的记录
      isXy: false,
      eqDivClass: 'booking-sea-eq-data-grid'
    }
  },
  computed: {
    isEcl() { // 海进委托拼箱
      return this.containerLoadType === 'ECL'
    },
    defaultEqSize() {
      return this.containerLoadType === 'FCL' && this.defaultSeaEQ.eqSize ? this.defaultSeaEQ.eqSize : '20'
    },
    defaultEqType() {
      return this.containerLoadType === 'FCL' && this.defaultSeaEQ.eqType ? this.defaultSeaEQ.eqType : 'GP'
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    fitSize() {
      if (this.hideContainerNo && this.hideSoc) {
        return 110
      }
      return 90
    },
    finalColumnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 100,
          hide: this.hideContainerNo,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true,
              classFunc: (params) => {
                return this.containerNbrStyleFunction(params.data)
              }
            },
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 100,
          hide: this.hideContainerNo,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              isUppercase: true,
              isTrim: true
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: this.fitSize,
          suppressMenu: true,
          lockVisible: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              labelFunc: item => {
                let text = item.name
                if (text && (this.containerLoadType === 'BB' || (this.job && !this.job.masterFlag && !!this.job.lclMasterUuid && this.containerLoadType === 'BCF') || this.isEcl)) {
                  text = 'PART OF ' + text
                }
                return text
              },
              value: 'code',
              filterable: false
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.eqSizes] }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: this.fitSize,
          suppressMenu: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-select',
            optionField: {
              labelFunc: item => {
                return item.code
              },
              value: 'code',
              filterable: true
            },
            attrs: {
              cellSelectAttrs: { fullOptions: [... this.eqTypes] },
              style: 'width:70px'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerAmount'),
          field: 'eqQuantity',
          width: this.fitSize,
          suppressMenu: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            min: 0,
            attrs: {
              style: 'width:65px'
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: 'SOC',
          field: 'soc',
          suppressMenu: true,
          width: 50,
          hide: this.hideSoc,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: false,
            tag: 'el-checkbox',
            valueChanged: p => { this.onCellChange(p) }
          }
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      this.rowData = newVal
      if (this.job.lob === 'SI') {
        this.eqDivClass = 'booking-sea-eq-data-grid-si'
      }
      this.selectedSeaEQ = null
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
    },
    containerLoadType: {
      immediate: true,
      async handler(newVal, oldVal) {
        // 第一次进入，暂停一下，在created之后执行
        if (typeof oldVal === 'undefined') {
          await sleep(0)
        }
        // 委托拼箱需要默认新增一个箱子
        const isAdd = (this.containerLoadType === 'BB' && !this.isXy) && (this.rowData.length === 0 || (!this.finalRowData || this.finalRowData.length <= 0))
        if (isAdd) {
          this.add()
        }
      }
    },
    isEdit(newVal) {
      for (const item of this.finalColumnDefs) {
        if (item.custom instanceof Object) {
          item.custom.isEdit = this.isEdit
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isXy = String(cache.config.get('ToExoSystem')) === 'XYCW'
    this.eqTypes = await getSpecificBasicData(basicCacheKeys.basic_data_EQType)
    if (this.job.lob === 'RI' || this.job.lob === 'RE' || this.lob === 'RE') {
      this.eqSizes = await EQ_SIZES_3
    }
    this.getDefaultSeaEQ()
    this.rowData = this.value
    for (const item of this.finalColumnDefs) {
      if (item.custom instanceof Object) {
        item.custom.isEdit = this.isEdit
      }
    }
  },
  methods: {
    async getDefaultSeaEQ() {
      const entityDefValUtil = EntityDefaultValueUtil.getInstance()
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      this.defaultSeaEQ = entityDefValUtil.seaEQ
    },
    add() {
      let eqSize = ''
      if (this.finalRowData.length === 0) {
        eqSize = this.defaultEqSize
      } else {
        const index = this.finalRowData.findIndex(p => p.eqType === this.defaultEqType && p.eqSize === this.defaultEqSize)
        if (index >= 0) {
          for (const item of this.eqSizes) {
            let isExist = false
            for (const subItem of this.finalRowData) {
              if (subItem.eqType === this.defaultEqType && subItem.eqSize === item.code) {
                isExist = true
                break
              }
            }
            if (!isExist) {
              eqSize = item.code
              break
            }
          }
        } else {
          eqSize = this.defaultEqSize
        }
      }
      if (!eqSize) {
        this.$message.warning(this.$t('Message.ASameBoxTypeExists'))
        return
      }
      const row = new SeaEQ().fillDefaultValue().getData()
      Object.assign(row, this.defaultSeaEQ)
      row.eqSize = eqSize
      row.eqType = this.defaultEqType
      row.eqQuantity = 1
      if (this.job.masterFlag) {
        row.joinContainerId = uidUtil.createUID()
      }
      row.jobUuid = this.job.uuid
      this.rowData.push(row)
      this.$nextTick(() => {
        if (this.gridApi) {
          this.gridApi.deselectAll()
          const nodes = this.gridApi.getRenderedNodes()
          const lastNode = nodes[nodes.length - 1]
          lastNode.setSelected(true)
          this.gridApi.setFocusedCell(nodes.length - 1, 'eqSize')
          this.selectedSeaEQ = lastNode.data
        }
      })

      this.job.seaEQ = this.rowData // 指向同一个 seaEQ
      // 装箱信息
      if (this.job.masterFlag) {
        if (this.containerLoadType === 'BCF') {
          ContainerUtil.autoJustContainerUsages(this.job)
        } else {
          ContainerUtil.autoAdjustMasterContainer(this.job)
        }
      } else {
        ContainerUtil.autoJustContainerUsages(this.job)
      }
      this.eqQuantityChange()
    },
    remove() {
      if (!this.selectedSeaEQ) {
        return
      }
      if (this.selectedSeaEQ.uuid) {
        // 检查: 已输入箱型箱种信息不能删
        if (this.job.masterFlag && !ContainerUtil.checkCanDelSeaEQ(this.selectedSeaEQ, this.job)) {
          this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
          return
        }
        // 检查: 海运进口主单已输入箱型箱种信息不能删
        if (this.job.masterFlag && this.job.lob === 'SI' && !ContainerUtil.checkCanDelSeaEQBySeqEQ(this.selectedSeaEQ)) {
          this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
          return
        }
        // 检查该箱型箱种能删的数量
        if (!this.job.masterFlag && !ContainerUtil.checkInputContainerNo(this.selectedSeaEQ, this.job)) {
          this.$message.info(this.$t('Message.ContainerSealInfoHasBeenEnteredCannotBeDeleted'))
          return
        }
        this.selectedSeaEQ.deleted = true
        /* 强制刷新finalRowData */
        /* const tempRowData = this.rowData
          this.rowData = []
          this.$nextTick(() => {
            this.rowData = tempRowData
          })*/
        const index = this.rowData.findIndex(p => p.uuid === this.selectedSeaEQ.uuid)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
        if (!this.job.delseaEQUuids) {
          this.job.delseaEQUuids = []
        }
        this.job.delseaEQUuids.push(this.selectedSeaEQ.uuid)
      } else {
        const index = this.rowData.findIndex(p => p === this.selectedSeaEQ)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      this.job.seaEQ = this.rowData // 指向同一个 seaEQ
      // 更新装箱信息中的箱型信息
      if (this.job.masterFlag) {
        if (this.containerLoadType === 'BCF') {
          ContainerUtil.autoJustContainerUsages(this.job)
        } else {
          ContainerUtil.autoAdjustMasterContainer(this.job)
        }
      } else {
        ContainerUtil.autoJustContainerUsages(this.job)
        // 【小票】关单信息 可用、且是【委托拼箱】时， 【关单信息】需要放到其中一个箱子里
        this.handleCustomsDeclaration()
      }

      // 当 箱型数==0 时 autoJustContainerUsages 中没有移除最后的装箱信息
      if (this.job.lob === 'SI') {
        if (this.job.seaEQ && this.job.seaEQ.length === 0) {
          if (this.job.containers) {
            if (!this.job.delContainerUuids) {
              this.job.delContainerUuids = []
            }
            for (const container of this.job.containers) {
              this.job.delContainerUuids.push(container.uuid)
            }
            this.job.containers = []
            this.job.containerUsages = []
          }
        }
      }

      // 锦昶专用，当箱货信息清空时，对应的装箱和装箱明细也要清空
      ContainerUtil.clearContainer(this.job)
      this.eqQuantityChange()
      this.selectedSeaEQ = null
    },
    async onCellChange(params) {
      this.$emit('cellChange', params)
      // 箱型箱种输入验证
      if (params.field === 'eqSize' || params.field === 'eqType') {
        if (ContainerUtil.checkSeaEq(this.job, params.data)) {
          this.$message.warning(this.$t('Message.ASameBoxTypeExists'))
          return
        }
        if (this.job.lob === 'SE' || this.job.lob === 'SI') {
          const row = params.data
          let eqSize = ''
          let eqType = ''
          if (params.field === 'eqSize') {
            eqSize = params.originalValue
            eqType = row.eqType
          }
          if (params.field === 'eqType') {
            eqSize = row.eqSize
            eqType = params.originalValue
          }
          let hasContainerNoOrSealNo = false
          if (this.job.containers && this.job.containers.length > 0) {
            for (const container of this.job.containers) {
              if (eqSize && eqType && eqSize === container.eqSize && eqType === container.eqType &&
                (!StrUtils.isEmpty(container.containerNo) || !StrUtils.isEmpty(container.sealNo))) {
                hasContainerNoOrSealNo = true
              }
            }
          }
          if (hasContainerNoOrSealNo) {
            let passThough = false
            await this.$confirm(this.$t('Message.HasContainerNoOrSealNoForSameEqTypeAndEqSize'), this.$t('Message.Prompt'), {
              confirmButtonText: lang.t('common.btn.ok'),
              cancelButtonText: lang.t('common.btn.cancel'),
              distinguishCancelAndClose: true,
              type: 'warning'
            }).then(() => {
              ContainerUtil.updateEqTypeOrEqSize(this.job, eqType, eqSize, params.data.eqType, params.data.eqSize)
              passThough = true
            }).catch(() => {
              if (params.field === 'eqSize') {
                params.data.eqSize = params.originalValue
              }
              if (params.field === 'eqType') {
                params.data.eqType = params.originalValue
              }
              passThough = false
            })
            if (!passThough) {
              this.$message.warning(this.$t('Message.SeaEqAsyncToContainerTip'))
              return
            }
          }
        }
      }

      // 装箱信息 （soc 编辑不影响container,usages 增删改）
      if (params.field !== 'soc') {
        if (this.job.masterFlag) {
          if (this.containerLoadType === 'BCF') {
            ContainerUtil.autoJustContainerUsages(this.job)
          } else {
            ContainerUtil.autoAdjustMasterContainer(this.job)
          }
        } else {
          ContainerUtil.autoJustContainerUsages(this.job)
          // 【小票】关单信息 可用、且是【委托拼箱】时， 【关单信息】需要放到其中一个箱子里
          this.handleCustomsDeclaration()
        }
      }
      // 箱号 封号 大写
      if (params.field === 'sealNo' || params.field === 'containerNo') {
        if (params.value) {
          params.value = params.value.toUpperCase()
        }
      }
      // soc状态改变
      if (params.field === 'soc') {
        if (this.job.containers) {
          for (const c of this.job.containers) {
            if (c.eqType === params.data.eqType && c.eqSize === params.data.eqSize && c.containerUsage) {
              for (const usage of c.containerUsage) {
                usage.soc = params.data.soc
              }
            }
            c.isDirty = true
          }
        }
      }
      // 箱量发生改变 给出弹框提示
      if (params && params.colId === 'eqQuantity' && params.value !== params.originalValue) {
        this.eqQuantityChange()
      }
    },
    handleCustomsDeclaration() {
      // 【小票】关单信息 可用、且是【委托拼箱】时， 【关单信息】需要放到其中一个箱子里
      if (this.slaveCustomsDeclarationEnable && this.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        if (this.job.containerUsages && this.job.containerUsages.length > 0 && this.job.poItems && this.job.poItems.length > 0) {
          const usage = this.job.containerUsages.find(p => p.poItems && p.poItems.length > 0)
          if (!usage) { // 若usage有值，即已经装箱了，则不处理
            this.job.containerUsages[0].poItems = this.job.poItems
            // 【关单信息】页签需要将这些poItems排查掉，否则创建重复
            this.job.poItems.forEach(p => {
              p.existInUsagedFlag = true
            })
            ContainerUtil.calcContainerUsageQWC(this.job.containerUsages[0], this.job)
          }
        }
      }
    },
    eqQuantityChange() {
      if (SEUtils.needTip(this.job, 'CNTR')) {
        this.$confirm(this.$t('Message.IfToRefreshTheContainers'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.$emit('eqQuantityChange')
        })
      }
    },
    rowClicked(event) {
      if (event) {
        this.selectedSeaEQ = event.data
      }
    },
    onUpCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            node.setSelected(true)
            this.selectedSeaEQ = node.data
          }
        })
      }
    },
    containerNbrStyleFunction(containerNo) {
      if (containerNo) {
        if (!ContainerNoHelper.checkContainerNo(containerNo.containerNo)) {
          return 'data-red'
        }
      }
      return ''
    },
    clear() {
      const job = this.job
      /* 清空seaEQ */
      job.delseaEQUuids = job.delseaEQUuids || []
      for (const item of this.rowData) {
        if (item.uuid) {
          job.delseaEQUuids.push(item.uuid)
        }
      }
      this.rowData.splice(0, this.rowData.length)
      /* 清空containers */
      if (job.containers) {
        job.delContainerUuids = job.delContainerUuids || []
        for (const item of job.containers) {
          if (item.uuid) {
            job.delContainerUuids.push(item.uuid)
          }
        }
        job.containers.splice(0, job.containers.length)
      }
      // 清空containerUsages
      job.delContainerUsageUuids = job.delContainerUsageUuids || []
      for (const item of job.containerUsages) {
        if (item.uuid) {
          job.delContainerUsageUuids.push(item.uuid)
        }
      }
      job.containerUsages.splice(0, job.containerUsages.length)
    }
  }
}
</script>

<style lang="scss">
.booking-sea-eq-data-grid {
  .ag-header-cell-text {
    color: #4283ff;
    font-weight: bold;
  }
}
booking-sea-eq-data-grid-si {
  .ag-header-cell-text {
    font-weight: bold;
  }
  .data-red {
     input.el-input__inner {
       color: #FF0000;
     }
   }
}
</style>
